<div class="ngx-backdrop-container" *ngIf='isVisible'>

  <div [class]='"ngx-backdrop-custom-backdrop " + backdropClass'>

    <div [class]='spinner'></div>

    <span *ngIf='text' [class]='"ngx-backdrop-loading-text " + textClass'>{{ text }} </span>

    <!-- <ng-content select=".backdrop-content"></ng-content> -->

  </div>
  
</div>